import Button from 'app/shared/components/button/Button';
import { PadExpand } from 'app/shared/components/misc';
import { useObservableBinding } from 'app/tools/hooks/misc-hooks';
import React from 'react';
import { BehaviorSubject } from 'rxjs';

type Props = {
  sending?: boolean;
  loading?: boolean;
  onSave?: () => void;
  editable$?: BehaviorSubject<boolean>;
  backInsteadOfCancel?: boolean;
};
export default function BottomEditActions({
  sending,
  loading,
  onSave,
  editable$: editIn$,
  backInsteadOfCancel,
}: Props): JSX.Element {
  const [editable, editable$] = useObservableBinding(
    editIn$ || false
  );

  const showEditButton = !editable && !sending;
  const showBackButton = backInsteadOfCancel && !showEditButton;
  const showSaveCancelButtons =
    !backInsteadOfCancel && !showEditButton;

  return (
    <>
      <PadExpand secondary />
      {showEditButton && (
        <Button
          onClick={() => editable$.next(true)}
          pending={loading}
        >
          Edit
        </Button>
      )}
      {showBackButton && (
        <Button
          onClick={() => editable$.next(false)}
          variant="outlined"
        >
          Back
        </Button>
      )}
      {showSaveCancelButtons && (
        <>
          <Button type="submit" pending={sending} onClick={onSave}>
            Save
          </Button>
          <Button
            variant="outlined"
            onClick={() => editable$.next(false)}
          >
            Cancel
          </Button>
        </>
      )}
    </>
  );
}
